module.exports = __webpack_public_path__ + "img/computer-checklist.16f6f6cf.svg";